import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterCommunicationService {
  private filterSource = new BehaviorSubject<any>(null);
  private resetFilterSource = new Subject<void>();
  currentFilter = this.filterSource.asObservable();
  resetFilterRequested = this.resetFilterSource.asObservable();

  constructor() {}

  changeFilter(filter: any) {
    this.filterSource.next(filter);
  }

  getCurrentFilter() {
    return this.filterSource.getValue();
  }

  resetFilter() {
    this.filterSource.next(null);
  }

  requestResetFilters() {
    this.resetFilterSource.next();
  }
}
